import { isArray } from '@ember/array';
import EmberObject, { get } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import ObjectProxy from '@ember/object/proxy'; // eslint-disable-line ember/no-proxies
import Money from '@square/dashboard-money/models/money';

/**
 * Negates all money objects and recursively for Ember Objects.
 *
 * To prevent misuse and confusion, proxied Ember objects are read-only.
 *
 * Usage: MoneyNegatorProxy.create({toNegate: objectToNegate}).
 */
// eslint-disable-next-line ember/no-classic-classes
const MoneyNegatorProxy = ObjectProxy.extend({
  toNegate: null,
  // passed in

  content: readOnly('toNegate'),
  // for ProxyMixin observers

  wrap(object) {
    if (object instanceof MoneyNegatorProxy) {
      return get(object, 'toNegate'); // un-negate an already-wrapped object
    } else if (object instanceof Money) {
      return get(object, 'negated');
    } else if (object instanceof EmberObject) {
      return MoneyNegatorProxy.create({
        toNegate: object
      });
    } else if (isArray(object)) {
      return object.map(element => this.wrap(element));
    }
    return object;
  },
  unknownProperty(key) {
    const result = this.get(`toNegate.${key}`);
    return result && this.wrap(result);
  },
  setUnknownProperty() {
    throw new Error('MoneyNegatorProxy negated objects are read-only');
  }
});
export default MoneyNegatorProxy;